import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { SampleMethodologyService } from "../../../Component/Api/VerificationAgency/SampleMethodology/SampleMethodologyService";
import { ConfirmationDialog } from "../../../Component/Common/Components/ConfirmationDialog";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { SampleMethodology } from "../../../Component/Model/Dto/VerificationAgency/SampleMethodology";
import { defaultObject } from "../../../Component/Model/helpers";
import { SampleMethodologiesEditModal } from "./SampleMethodologiesEditModal";
import { SampleMethodologiesTableMapper } from "./SampleMethodologiesTable";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../../State/user.Atom";

export const SampleMethodologiesPage = () => {
    const [sampleMethodologiesData, setSampleMethodologiesData] = useState<
        SampleMethodology.SampleMethodologyData[]
    >([]);
    const [isLoading, setIsLoading] = useState(false);
    const [entriesPerPage, setEntriesPerPage] = React.useState(10);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [showEditMethodology, setShowEditMethodology] = useState<boolean>(false);
    const [selectedMethodologyId, setSelectedMethodologyId] = useState<string>("");
    const [selectedMethodologyElementId, setSelectedMethodologyElementId] = useState<number>(1);
    const [showClearConfirmationDialog, setShowClearConfirmationDialog] = useState(false);
    const user = useRecoilValue(UserAtom);
    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage(entriesPerPage);
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const getData = async () => {
        setIsLoading(true);
        try {
            const methodologiesResult = await SampleMethodologyService.getAllSampleMethodology();
            setSampleMethodologiesData(methodologiesResult.data);
            setTotalItemsCount(methodologiesResult.data.length);
            setFilteredItemsCount(methodologiesResult.data.length);
        } catch (error) {
            setSampleMethodologiesData(defaultObject);
            setFilteredItemsCount(0);
            setTotalItemsCount(0);
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, [entriesPerPage, pageNumber]);

    const indexOfLastPage = pageNumber * entriesPerPage;
    const indexOfFirstPage = indexOfLastPage - entriesPerPage;

    const currentData = sampleMethodologiesData.slice(
        indexOfFirstPage,
        indexOfLastPage
    );

    const setEditMethodology = (id: string) => {
        setSelectedMethodologyId(id);
        setShowEditMethodology(true);
    }
    function handleCloseEditMethodology(): void {
        setShowEditMethodology(false);
        getData();
    }

    const closeClearConfimation = () => {
        setShowClearConfirmationDialog(false);
        getData();
    };

    const confirmClearMessage = "Are you sure you want to clear this methodology?";

    const handleClear = async () => {
        try {
            await SampleMethodologyService.clearSampleMethodologyById(selectedMethodologyElementId)
            toast.success("Successfully Cleared Selected Methodology ");
        } catch (error) {
            console.log(error);
        } finally {
            closeClearConfimation();
        }
    }

    const showClearMethodology = (id: number) => {
        setSelectedMethodologyElementId(id)
        setShowClearConfirmationDialog(true);
    };

    const sampleMethodologyTableData = SampleMethodologiesTableMapper(
        currentData,
        setEditMethodology,
        showClearMethodology
    );

    return (
        <>
            <DataTable
                key={totalItemsCount}
                table={sampleMethodologyTableData}
                filteredItemsCount={filteredItemsCount}
                entriesPerPage={{ defaultValue: entriesPerPage }}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                pageNumber={pageNumber}
                isLoading={isLoading}
                isSorted={false}
            ></DataTable>
            <ConfirmationDialog
                showDialog={showClearConfirmationDialog}
                handleAccept={handleClear}
                handleCancel={closeClearConfimation}
                heading={"Confirm Clear"}
                message={confirmClearMessage}
            />
            {showEditMethodology && (
                <SampleMethodologiesEditModal sampleMethodologyId={selectedMethodologyId} showEditMethodologyModal={showEditMethodology} isEditable={user.isAdmin} closeEditMethodologyModal={handleCloseEditMethodology}
                />
            )}
        </>
    );
};